module.exports = __webpack_public_path__ + "img/edit_disabled.d84fe73e.svg";